export default "__VITE_ASSET__5016b17e__"